import get from "lodash/get";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const useWork = (variables) => {
  const workId = parseInt(variables.workId, 10);

  const { data, loading } = useQuery(
    gql`
      query work($workId: Int!, $locale: String!) {
        work(workId: $workId, locale: $locale) {
          id
          title
          description
          remoteKey
          artist {
            id
            name
            shopUrl
            username
          }
        }
      }
    `,
    {
      variables: {
        ...variables,
        workId,
      },
      skip: Number.isNaN(workId),
    }
  );

  const work = get(data, "work");

  if (!work) {
    return { work, loading };
  }

  const description = get(data, "work.description");
  const title = get(data, "work.title");
  const remoteKey = get(data, "work.remoteKey");
  const name = get(data, "work.artist.name");
  const username = get(data, "work.artist.username");
  const shopUrl = get(data, "work.artist.shopUrl");
  const artistId = get(data, "work.artist.id");
  const id = get(data, "work.id");

  return {
    work: {
      id,
      description,
      title,
      remoteKey,
      artistId,
      name,
      username,
      shopUrl,
    },
    loading,
  };
};

export default useWork;
